module.exports = __webpack_public_path__ + "img/readAndLeisure.c36ac6d2.png";